/**
 * `location.state` contract for "land on the Messages tab with the composer
 * focused" — what the ⌘K quick launcher's "Text <patient>" does.
 *
 * A timestamp, not a boolean: re-navigating to the tab you are already on
 * with an unchanged `location.state` does not change the effect's deps in
 * `MessagesInput`, so a boolean would focus once and then look broken. Kept in
 * its own module so the launcher can import the key without pulling the
 * TinyMCE-backed input into the app shell's bundle.
 */
export const FOCUS_COMPOSER_STATE_KEY = "focusComposerAt" as const;

export type FocusComposerLocationState = {
  [FOCUS_COMPOSER_STATE_KEY]?: number;
};

export const focusComposerState = (): FocusComposerLocationState => ({
  [FOCUS_COMPOSER_STATE_KEY]: Date.now()
});
